import { useConfigureController } from '../../hooks/useController'

import { Form } from './components/Form'

type Props = {
  userId: string
}

export function Content(props: Props) {
  const { ready } = useConfigureController(props.userId)

  if (!ready) return null

  return <Form />
}
